<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M34.762 12.999L42.1155 13.6929L42.5906 20.8276" stroke="black" stroke-width="2" stroke-miterlimit="10"/>
<path d="M42.1032 13.6807L32.4441 23.3398" stroke="black" stroke-width="2" stroke-miterlimit="10"/>
<path d="M43.0012 34.7617L42.3074 42.1152L35.1726 42.5903" stroke="black" stroke-width="2" stroke-miterlimit="10"/>
<path d="M42.3073 42.1147L32.6604 32.4434" stroke="black" stroke-width="2" stroke-miterlimit="10"/>
<path d="M21.238 43.0005L13.8845 42.3066L13.4094 35.1719" stroke="black" stroke-width="2" stroke-miterlimit="10"/>
<path d="M13.9861 42.23L23.556 32.6602" stroke="black" stroke-width="2" stroke-miterlimit="10"/>
<path d="M12.999 21.2378L13.6929 13.8843L20.8276 13.4092" stroke="black" stroke-width="2" stroke-miterlimit="10"/>
<path d="M13.6929 13.8848L23.3397 23.5561" stroke="black" stroke-width="2" stroke-miterlimit="10"/>
</svg>
